import { api } from './client';

export async function signup({ email, password, name }) {
  let timezone = null;
  try {
    timezone = Intl.DateTimeFormat().resolvedOptions().timeZone || null;
  } catch {
    timezone = null;
  }
  const data = await api.post('/auth/signup', { email, password, name, timezone });
  if (data.access_token) localStorage.setItem('access_token', data.access_token);
  if (data.refresh_token) localStorage.setItem('refresh_token', data.refresh_token);
  return data;
}

export async function login({ email, password }) {
  const data = await api.post('/auth/login', { email, password });
  localStorage.setItem('access_token', data.access_token);
  localStorage.setItem('refresh_token', data.refresh_token);
  return data;
}

export async function logout() {
  try {
    await api.post('/auth/logout');
  } finally {
    localStorage.removeItem('access_token');
    localStorage.removeItem('refresh_token');
  }
}

export async function getMe() {
  return api.get('/users/me');
}

export async function markTourSeen() {
  return api.post('/users/me/tour-seen');
}

export async function resetPassword(email) {
  return api.post('/auth/reset-password', { email });
}

export async function updatePassword(password) {
  return api.post('/auth/update-password', { password });
}

export async function changePassword({ currentPassword, newPassword }) {
  return api.post('/auth/change-password', { currentPassword, newPassword });
}
